import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RankingMetricasQualidadeProvider,
  useRankingMetricasQualidade,
} from "./context/RankingMetricasQualidadeContext";
import { RankingMetricasQualidadeView } from "./components/RankingMetricasQualidadeView";

const RankingMetricasQualidadeContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    snapshots,
    snapshotsPreviousPeriod,
    isLoadingSnapshots,
    isLoadingSnapshotsPreviousPeriod,
    lojas,
    isLoading,
    selectedLojaId,
    showLojaSelector,
    selectedDateISO,
    setSelectedDateISO,
    selectedPeriod,
    setSelectedPeriod,
    selectedPeriodLabel,
    comparisonPeriodLabel,
    dateLabel,
    comparisonDateLabel,
    selectedDateDayMonth,
    comparisonDateDayMonth,
    selectedLojaNome,
    toggleLojaSelector,
    selectAllLojas,
    selectLoja,
  } = useRankingMetricasQualidade();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-red-900 text-white">
        <div className="text-center">
          <p className="text-xl">Carregando ranking...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingMetricasQualidadeView
      snapshots={snapshots}
      snapshotsPreviousPeriod={snapshotsPreviousPeriod}
      isLoadingSnapshots={isLoadingSnapshots}
      isLoadingSnapshotsPreviousPeriod={isLoadingSnapshotsPreviousPeriod}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={showLojaSelector}
      selectedDateISO={selectedDateISO}
      onSelectedDateChange={setSelectedDateISO}
      selectedPeriod={selectedPeriod}
      onSelectedPeriodChange={setSelectedPeriod}
      selectedPeriodLabel={selectedPeriodLabel}
      comparisonPeriodLabel={comparisonPeriodLabel}
      dateLabel={dateLabel}
      comparisonDateLabel={comparisonDateLabel}
      selectedDateDayMonth={selectedDateDayMonth}
      comparisonDateDayMonth={comparisonDateDayMonth}
      selectedLojaNome={selectedLojaNome}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaSelector}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
    />
  );
};

const RankingMetricasQualidadePage: React.FC = () => {
  return (
    <RankingMetricasQualidadeProvider>
      <RankingMetricasQualidadeContent />
    </RankingMetricasQualidadeProvider>
  );
};

export default RankingMetricasQualidadePage;
export { RankingMetricasQualidadeView } from "./components/RankingMetricasQualidadeView";
export type { RankingMetricasQualidadeViewProps } from "./types";
